// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"b9f080fd","628":"b9a3f3a5","766":"4508b73a"}[chunkId] + ".chunk.css";
};